<template>
    <div class="full-width-record" ref="shopItemRecordDom" v-loading="loading">
        <el-row :gutter="12">
            <el-col :span="colSpan" v-for="(v, i) in recordList" :key="v.id" style="margin-bottom: 12px;">
                <shopItem :item="v" @clickDelete="delItem" @clickEdit="editItem" />
            </el-col>
        </el-row>

        <paginationComponent :pageObj="pageObj" @goPage="changePage" />
    </div>
</template>

<script setup>
    import shopItem from "@/components/shopopee/shop/shopItem"
    import paginationComponent from "@/components/shopopee/common/paginationComponent"
    import {toRef, ref, onMounted, getCurrentInstance, inject} from "vue";
    import { useUserinfo } from '@/stores/userinfo'
    import myUtil from "@/util/util";
    import materialApi from "@/request/materialApi";
    import eshopopeeApi from "@/request/eshopopeeApi";

    const emits = defineEmits(["goEdit","goAdd"])

    const { proxy } = getCurrentInstance()

    const userinfoRef = toRef(useUserinfo())

   // const shopCompany = ref({})
    const width = ref(425)
    const colSpan = ref(24)


    const pageObj = ref({})
    const recordList = ref([])

    const loading = ref(false)

    const pageNum = ref(1)
    const pageSize = ref(5)

    let currObj = null

    function getShopItemList(){
        loading.value = true
        const request = materialApi.queryMaterialByPage
        const params = request.getParams()

        //params.companycode = shopCompany.value.companycode
        params.companycode =userinfoRef.value.selectCompanycode
        // params.memberid = userInfoRef.value.businessId
        params.pageNum = pageNum.value
        params.pageSize = pageSize.value

        request.send(params, fillShopItem)
    }

    function fillShopItem(res){
        loading.value = false

        if (res.code == 200){
            pageObj.value = res.detail
            recordList.value = res.detail.list
          if(recordList.value.length<1){
            emits("goAdd")
          }
        }else{
            myUtil.alertError(res.msg)
            recordList.value = []
            res.detail = {}

          emits("goAdd")

        }
    }

    function delItem(obj) {
        currObj = obj

        takeDownItem(obj.id)
    }

    function takeDownItem(id){
        const request = materialApi.takeDownMaterial
        const params = request.getParams()

        params.id = id

        request.send(params, takeDownCallback)
    }

    function takeDownCallback(res){
        if (res.code == 200){
            if (recordList.value.length === 1 && pageNum.value > 1){
                pageNum.value -= 1
            }

            getShopItemList()

            takeDownEShopopeeItem()

            myUtil.alertSuccess("刪除成功")
        }else{
            myUtil.alertError(res.msg)
        }
    }

    function takeDownEShopopeeItem(){
        if (null == currObj){
            return
        }

        const request = eshopopeeApi.takeDownMaterial
        const params = request.getParams()

        params.CompanyCodes = currObj.acccode
        params.ProductID = currObj.productid

        request.send(params, takeDownEShopopeeItemCallback)
    }

    function takeDownEShopopeeItemCallback(res){
        console.log(res)
    }

    function changePage(page){
        pageNum.value = page

        getShopItemList()

    }

    function editItem(obj){
        emits("goEdit", obj)
    }

    onMounted(() => {
        width.value = proxy.$refs.shopItemRecordDom.offsetWidth

        if (width.value > 1800){
            colSpan.value = 4
            pageSize.value = 12
        }else if (width.value > 1200){
            colSpan.value = 6
            pageSize.value = 8
        }else if (width.value > 900){
            colSpan.value = 8
            pageSize.value = 6
        }else if(width.value > 600){
            colSpan.value = 12
            pageSize.value = 6
        }else{
            colSpan.value = 12
            pageSize.value = 4
        }

        getShopItemList()
    })
</script>

<style scoped>
    .full-width-record {
        width: 100%;
    }
</style>